import * as Sentry from '@sentry/react'

const dsn = import.meta.env.VITE_SENTRY_DSN as string | undefined

export const SentryService = {
  enabled: Boolean(dsn),

  initialize() {
    if (!dsn) return
    Sentry.init({
      dsn,
      environment: (import.meta.env.VITE_SENTRY_ENVIRONMENT as string | undefined) || import.meta.env.MODE,
      release: import.meta.env.VITE_APP_VERSION as string | undefined,
      sendDefaultPii: false,
      tracesSampleRate: 0,
    })
  },

  setContext(context: { host?: string; branch_id?: string | null; terminal_id?: string | null; staff_id?: string | null }) {
    if (!dsn) return
    Sentry.setTags({
      host: context.host ?? window.location.hostname,
      branch_id: context.branch_id ?? 'none',
      terminal_id: context.terminal_id ?? 'none',
    })
    Sentry.setUser(context.staff_id ? { id: context.staff_id } : null)
  },

  captureException(error: unknown, extra?: Record<string, unknown>) {
    if (!dsn) return
    Sentry.captureException(error, extra ? { extra } : undefined)
  },
}
